// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"4c9c2051","159":"2de2067a","293":"16dc922a","589":"d661d4d5"}[chunkId] + ".chunk.js";
};